import React, { useEffect, useState } from 'react';
import { Button } from './ui/Button';
import { MenuIcon, XIcon } from 'lucide-react';
import { Link } from 'react-router-dom';
export function Navigation() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isScrolled, setIsScrolled] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  const navLinks = [{
    name: 'About Us',
    href: '/about'
  }, {
    name: 'Treatments',
    href: '/treatments'
  }, {
    name: 'Financing',
    href: '/financing'
  }, {
    name: 'Testimonials',
    href: '/testimonials'
  }, {
    name: 'Specials',
    href: '/#specials'
  }, {
    name: 'Membership',
    href: '/#membership'
  }, {
    name: 'Blog',
    href: '/blog'
  }];
  return <nav className={`fixed top-0 left-0 right-0 z-[100] transition-all duration-300 ${isScrolled ? 'bg-black/95 backdrop-blur-sm shadow-lg' : 'bg-transparent'}`} data-id="element-1671">
      <div className="max-w-[1200px] mx-auto px-4 lg:px-8" data-id="element-1672">
        <div className="flex h-16 lg:h-20 items-center justify-between" data-id="element-1673">
          {/* Logo */}
          <Link to="/" className="flex items-center gap-2 flex-shrink-0" data-id="element-1674">
            <img src="https://cdn.magicpatterns.com/uploads/hrXX85rhn4YR9sbdgFXsGs/beclinical.svg_(1).png" alt="Be Clinical" className="h-10 w-auto" data-id="element-1675" />
          </Link>

          {/* Desktop Nav */}
          <div className="hidden lg:flex items-center gap-6 xl:gap-8" data-id="element-1676">
            {navLinks.map(link => <a key={link.name} href={link.href} className="text-[13px] uppercase tracking-widest text-white hover:text-[#FF1493] transition-colors relative after:absolute after:bottom-[-2px] after:left-0 after:w-0 after:h-[1px] after:bg-[#FF1493] after:transition-all hover:after:w-full" data-id="element-1677">
                {link.name}
              </a>)}
            <Button variant="primary" size="sm" data-id="element-1678">
              Book Consult
            </Button>
          </div>

          {/* Mobile Menu Button */}
          <button className="lg:hidden p-2 text-white" onClick={() => setIsMenuOpen(!isMenuOpen)} aria-label={isMenuOpen ? 'Close menu' : 'Open menu'} data-id="element-1679">
            {isMenuOpen ? <XIcon size={24} data-id="element-1680" /> : <MenuIcon size={24} data-id="element-1681" />}
          </button>
        </div>
      </div>

      {/* Mobile Full-Screen Overlay */}
      {isMenuOpen && <div className="lg:hidden fixed inset-0 z-50 bg-[#111111] overflow-y-auto flex flex-col items-center justify-center gap-8 p-8 pt-24" data-id="element-1682">
          {/* Close Button */}
          <button onClick={() => setIsMenuOpen(false)} className="absolute top-6 right-6 p-2 text-white hover:text-[#FF1493] transition-colors" aria-label="Close menu" data-id="element-1683">
            <XIcon size={28} data-id="element-1684" />
          </button>

          {navLinks.map(link => <a key={link.name} href={link.href} onClick={() => setIsMenuOpen(false)} className="text-lg uppercase tracking-widest text-white hover:text-[#FF1493] transition-colors font-heading" data-id="element-1685">
              {link.name}
            </a>)}
          <Button variant="primary" size="lg" className="w-full max-w-xs mt-4" onClick={() => setIsMenuOpen(false)} data-id="element-1686">
            Book Consult
          </Button>
        </div>}
    </nav>;
}